import {
    useEffect,
    useState
}
from "react";

import {functions} from "../../../constants/common-functions";

export default function useFloorPlan(
    floorId)
{
    const [floorPlan, setFloorPlan] =
        useState(null);

    const [loading, setLoading] =
        useState(false);

    const [error, setError] =
        useState(null);

    useEffect(
		
        function()
        {
            if(!floorId)
            {
                setFloorPlan(null);
                return;
            }

            loadFloorPlan();
        },
        [floorId]
    );

	function loadFloorPlan()
	    {
	        setLoading(true);

	        functions.getObjectFromAjax(
	            "/resolutionsoftwareplatform/spaceorgfloorplan/" +
	            floorId,
	            function(data)
	            {
	                setFloorPlan(
	                    data
	                );

	                setLoading(
	                    false
	                );
	            },
	            null
	        );
	    }

    return {
        floorPlan,
        loading,
        error,
        reload: loadFloorPlan
    };
}